import {
  BankOutlined,
  CreditCardOutlined,
  DeploymentUnitOutlined,
  DollarOutlined,
  IssuesCloseOutlined,
  LineChartOutlined,
  LoginOutlined,
  LogoutOutlined,
  RetweetOutlined,
  SolutionOutlined,
  StopOutlined,
  UserOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import { Badge, Layout, Menu } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { Urls, userRoles } from '#constants';

import logoSmall from './logo_small.png';

import classes from './styles.module.scss';

const { Sider } = Layout;

export const Sidebar = ({ collapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const userRole = useSelector((state) => state.userData.user.role);
  const isTrader = userRole === userRoles.Trader;
  const isTraderAgent = userRole === userRoles.TraderAgent;
  const incomeCount = useSelector((state) => state.incomesPage?.countNew);
  const outcomeCount = useSelector((state) => state.outcomesPage?.countNew);
  const isTraderRelated = [userRoles.Trader, userRoles.TraderAgent].includes(
    userRole
  );

  const getItem = useCallback(
    (label, key, icon, children, type) => ({
      children,
      icon,
      key,
      label,
      type
    }),
    []
  );

  const selectedKey = useMemo(() => {
    const urls = Object.values(Urls).slice(1);

    return (
      urls.findIndex((el) => {
        return location.pathname.includes(el);
      }) + 1 || 1
    );
  }, [location]);

  console.log(selectedKey);

  return (
    <Sider collapsed={collapsed} collapsible trigger={null}>
      <NavLink to={Urls.OutcomePage}>
        <div className={classes.logo}>
          <img src={logoSmall} />
        </div>
      </NavLink>

      <Menu
        defaultOpenKeys={[]}
        items={[
          getItem(
            <NavLink to={Urls.OutcomePage}>
              {t('Payouts')}
              <Badge
                count={outcomeCount}
                offset={[10, -2]}
                size={'small'}
                style={{ backgroundColor: '#faad14', color: '#000' }}
              />
            </NavLink>,
            '1',
            <LogoutOutlined />
          ),
          getItem(
            <NavLink to={Urls.IncomePage}>
              {t('Receipts')}
              <Badge
                count={incomeCount}
                offset={[10, -2]}
                size={'small'}
                style={{ backgroundColor: '#faad14', color: '#000' }}
              />
            </NavLink>,
            '2',
            <LoginOutlined />
          ),
          getItem(
            <NavLink to={Urls.Profile}>{t('Profile')}</NavLink>,
            '3',
            <UserOutlined />
          ),
          isTrader && [
            getItem(
              <NavLink to={Urls.Operators}>{t('Operators')}</NavLink>,
              '4',
              <UserSwitchOutlined />
            )
          ],
          isTraderRelated && [
            getItem(
              <NavLink to={Urls.Cards}>{t('Cards')}</NavLink>,
              '5',
              <CreditCardOutlined />
            )
          ],
          isTraderRelated && [
            getItem(
              <NavLink to={Urls.Tariffs}>{t('Tariffs')}</NavLink>,
              '6',
              <DollarOutlined />
            )
          ],
          isTraderRelated && [
            getItem(
              <NavLink to={Urls.Banks}>{t('Banks')}</NavLink>,
              '7',
              <BankOutlined />
            )
          ],
          isTraderRelated && [
            getItem(
              <NavLink to={Urls.Devices}>{t('Devices')}</NavLink>,
              '8',
              <DeploymentUnitOutlined />
            )
          ],
          isTrader && [
            getItem(
              <NavLink to={Urls.Holders}>{t('Holders')}</NavLink>,
              '9',
              <SolutionOutlined />
            )
          ],

          isTraderRelated && [
            getItem(
              <NavLink to={Urls.Corrections}>
                {t('Balance corrections')}
              </NavLink>,
              '10',
              <RetweetOutlined />
            )
          ],
          getItem(
            <NavLink to={Urls.Debtors}>{t('Debtors')}</NavLink>,
            '11',
            <IssuesCloseOutlined />
          ),
          {
            children: [
              getItem(
                <NavLink to={Urls.GreyList}>{t('Temporary')}</NavLink>, // временный + постоянный
                '18'
              ),
              getItem(
                <NavLink to={Urls.BlackList}>{t('Permanent')}</NavLink>, // временный + постоянный
                '17'
              )
            ],
            icon: <StopOutlined />,
            key: 'SubMenu',
            label: 'Black list'
          },

          isTrader && [
            getItem(
              <NavLink to={Urls.Statistic}>{t('Statistics')}</NavLink>,
              '14',
              <LineChartOutlined />
            )
          ],
          isTrader && [
            getItem(
              <NavLink to={Urls.CardStatement}>{t('Card statement')}</NavLink>,
              '15',
              <LineChartOutlined />
            )
          ]
          // isAdmin && [
          //   getItem(
          //     <NavLink to={Urls.Settings}>{t('Settings')}</NavLink>,
          //     '20',
          //     <LineChartOutlined />
          //   )
          // ]
        ].flat()}
        mode="inline"
        selectedKeys={[selectedKey.toString()]}
        theme="dark"
      />
    </Sider>
  );
};
